import { z } from 'zod';
import { objectiveInvestigationHandoffSchema, type ObjectiveInvestigationHandoff } from './saved-investigation';
import type { SynergyLoopRevision } from './synergy-loop.v1';

const revisionSchema = z.object({ datasetRef: z.string().min(1), revisionId: z.string().min(1),
  version: z.number().int().nonnegative() }).strip();

/** Preserve native identities without making supplemental metadata a figure-render gate. */
export function readSynergyLoopIdentity(value: { investigation?: unknown; landingRevision?: unknown }): {
  investigation?: ObjectiveInvestigationHandoff; landingRevision?: SynergyLoopRevision;
} | null {
  const investigation = objectiveInvestigationHandoffSchema.safeParse(value.investigation);
  const saved = investigation.success ? { investigation: investigation.data } : {};
  if (value.landingRevision === undefined) return saved;
  const revision = revisionSchema.safeParse(value.landingRevision);
  return revision.success ? { ...saved, landingRevision: revision.data } : null;
}
